import type React from 'react';

function ElementLogicIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 610.38 610.38" {...props}>
      <title>ElementLogicIcon</title>

      <g id="Lager_1-2" data-name="Lager 1">
        <g>
          <path
            d="M270.36,260.18h68.92v69.94h-11.87v-55.53h-15.25v55.43h-13.83v-55.45h-15.16v55.37h-12.8v-69.76Z"
            fill="currentColor"
          />
          <path
            d="M83,317.4v12.58H13.38v-69.61H82.98v13.44H26.34v15.15h56.65v13.25c-16.5,0-32.62,.35-48.71-.16-7.15-.22-8.83,2.43-8.6,9.03,.18,5.31,2.3,6.45,6.98,6.38,13.71-.19,27.42-.07,41.14-.06,2.94,0,5.87,0,9.2,0Z"
            fill="currentColor"
          />
          <path
            d="M254,330.04h-69.36v-69.8h69.4v13.4h-56.1c-.3,3.04-.43,5.16-.74,7.25-.95,6.41,1.47,8.64,8.14,8.45,16.11-.47,32.24-.15,48.7-.15v12.82h-56.06v15.23h56.02v12.8Z"
            fill="currentColor"
          />
          <path
            d="M356.02,260.19h69.38v13.44h-56.16c-.28,3.02-.39,5.14-.7,7.23-.93,6.4,1.47,8.66,8.15,8.47,16.11-.47,32.25-.15,48.71-.15v13.1h-56.37v14.91h56.3v12.72h-69.31v-69.72Z"
            fill="currentColor"
          />
          <path
            d="M511.07,260.18v69.78h-12.47v-55.39h-43.87v55.18h-13.16v-69.57h69.5Z"
            fill="currentColor"
          />
          <path
            d="M568.45,330.11h-13.02v-56.1h-28.08v-13.64h69.65v13.31h-28.54v56.44Z"
            fill="currentColor"
          />
          <path
            d="M98.89,330.46v-70.05h12.8c0,12.07,0,24.09,0,36.11q0,20.88,21.19,20.88h35.75v13.06H98.89Z"
            fill="currentColor"
          />
          <path d="M583.82,289.62h13.17v40.19h-13.17v-40.19Z" fill="currentColor" />
          <path d="M127.48,260.02h11.74v41.61h-11.74v-41.61Z" fill="currentColor" />
          <path d="M156.36,259.92h12.1v41.81h-12.1v-41.81Z" fill="currentColor" />
          <path d="M482.55,330.15h-12.49v-40.51h12.49v40.51Z" fill="currentColor" />
          <path d="M527.55,289.52h12.18v40.45h-12.18v-40.45Z" fill="currentColor" />
        </g>
        <rect width="610.38" height="610.38" fill="none" />
      </g>
    </svg>
  );
}

export default ElementLogicIcon;
